/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Geofences Polygon Icon component.
 */
export const GeofencesPolygonIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M10.0227 2.50256L2.34627 9.81815C2.1526 10.0027 2.13853 10.307 2.31435 10.5087L11.9376 21.5461C12.1433 21.782 12.5127 21.7731 12.7067 21.5275L22.3599 9.31207C22.619 8.98421 22.3855 8.50206 21.9676 8.50206H13.5838C13.3817 8.50206 13.1995 8.38043 13.122 8.19381L10.8294 2.67277C10.6948 2.34859 10.2768 2.2604 10.0227 2.50256Z' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' />
    </svg>
  );
};

export default GeofencesPolygonIcon;
